import { TRIAL_MOCK_IDS } from '../constants';

// ── Groups (shared across group list + member filters) ──

const MOCK_GROUPS = [
  {
    id: 'trial-grp-001',
    name: 'Yoga Morning Batch',
    amount: '1500',
    interval: 'monthly',
    intervalFrequency: 1,
    is_active: true,
    is_payment_link_sent: true,
    is_split_payment: false,
    member_count: 8,
    active_member_count: 7,
    pay_due: '3000',
    pay_received: '9000',
    pending_count: 2,
    image_url: ''
  },
  {
    id: 'trial-grp-002',
    name: 'Swimming Advanced',
    amount: '2500',
    interval: 'monthly',
    intervalFrequency: 1,
    is_active: true,
    is_payment_link_sent: true,
    is_split_payment: false,
    member_count: 5,
    active_member_count: 5,
    pay_due: '2500',
    pay_received: '10000',
    pending_count: 1,
    image_url: ''
  },
  {
    id: 'trial-grp-003',
    name: 'Dance Beginners',
    amount: '1000',
    interval: 'monthly',
    intervalFrequency: 1,
    is_active: true,
    is_payment_link_sent: false,
    is_split_payment: false,
    member_count: 4,
    active_member_count: 3,
    pay_due: '1000',
    pay_received: '3000',
    pending_count: 1,
    image_url: ''
  }
];

export const getGroupsListMock = (
  page: number,
  limit: number,
  status: string
) => {
  const filtered = status === 'inactive' ? [] : MOCK_GROUPS;
  const start = page * limit;
  const slice = filtered.slice(start, start + limit);
  return {
    data: slice,
    pagination: {
      total_rows: filtered.length,
      page,
      limit,
      last_page: start + limit >= filtered.length
    }
  };
};

export const getGroupsWithoutPaginationMock = () => MOCK_GROUPS;

export const getGroupDetailMock = (groupId: string) => {
  const group = MOCK_GROUPS.find((g) => g.id === groupId) || MOCK_GROUPS[0];
  return {
    id: group.id,
    name: group.name,
    amount: group.amount,
    frequency: group.interval,
    interval_frequency: group.intervalFrequency,
    is_active: group.is_active,
    is_payment_link_sent: group.is_payment_link_sent,
    is_split_payment: group.is_split_payment,
    is_fee_configured: false,
    start_date: '2026-01-01T00:00:00Z',
    next_due_at: '2026-05-01T00:00:00Z',
    interval_execution_type: 'scheduled',
    member_count: group.member_count,
    active_member_count: group.active_member_count,
    image_url: '',
    payment_schedule: {
      interval: group.interval,
      monthly_config: null,
      weekly_config: null,
      term_details: null
    },
    collection_started_at: '2026-01-01T00:00:00Z',
    is_attendance_tracking_enabled: false,
    is_attendance_marked: false,
    group_fee_amount_configuration: [],
    payment_stats: {
      pay_received: group.pay_received,
      pay_due: group.pay_due,
      pending_count: group.pending_count
    },
    payment_list: (() => {
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ];
      const yr = new Date().getFullYear();
      const perMonth = parseInt(group.pay_received, 10) / 12;
      const duePerMonth = parseInt(group.pay_due, 10) / 12;
      return months.map((m) => ({
        payment_month: m,
        payment_year: yr,
        payment_due: duePerMonth.toFixed(2),
        payment_received: perMonth.toFixed(2)
      }));
    })()
  };
};

// ── Members (15 members spread across 3 groups) ──

const FIRST_NAMES = [
  'Aarav',
  'Priya',
  'Rohan',
  'Meera',
  'Arjun',
  'Ananya',
  'Vikram',
  'Sneha',
  'Karthik',
  'Divya',
  'Rahul',
  'Ishita',
  'Aditya',
  'Nisha',
  'Suresh'
];

const LAST_NAMES = [
  'Sharma',
  'Patel',
  'Nair',
  'Reddy',
  'Kumar',
  'Gupta',
  'Menon',
  'Iyer',
  'Singh',
  'Das',
  'Joshi',
  'Verma',
  'Rao',
  'Pillai',
  'Mishra'
];

const GROUP_ASSIGNMENTS = [
  [MOCK_GROUPS[0]],
  [MOCK_GROUPS[1]],
  [MOCK_GROUPS[0], MOCK_GROUPS[2]],
  [MOCK_GROUPS[2]],
  [MOCK_GROUPS[0]],
  [MOCK_GROUPS[1]],
  [MOCK_GROUPS[0]],
  [MOCK_GROUPS[1], MOCK_GROUPS[2]],
  [MOCK_GROUPS[2]],
  [MOCK_GROUPS[0]],
  [MOCK_GROUPS[1]],
  [MOCK_GROUPS[0]],
  [MOCK_GROUPS[2]],
  [MOCK_GROUPS[1]],
  [MOCK_GROUPS[0], MOCK_GROUPS[1]]
];

const MOCK_MEMBERS = FIRST_NAMES.map((first, i) => ({
  id: `trial-member-${String(i + 1).padStart(3, '0')}`,
  name: `${first} ${LAST_NAMES[i]}`,
  country_code: '91',
  mobile: `98${String(70000000 + i * 1111111).slice(0, 8)}`,
  groups: GROUP_ASSIGNMENTS[i].map((g) => ({
    id: g.id,
    name: g.name
  })),
  guardian_name: i % 3 === 0 ? `${LAST_NAMES[(i + 5) % 15]} Sr.` : '',
  admission_number: `ACM-${2026}${String(i + 1).padStart(3, '0')}`,
  total_due:
    i % 4 === 0 ? [{ amount: '1500', group_name: MOCK_GROUPS[0].name }] : [],
  processing: []
}));

export const getMembersMock = (
  page: number,
  limit: number,
  search: string,
  groupId: string
) => {
  let filtered = MOCK_MEMBERS;

  if (search) {
    const term = search.toLowerCase();
    filtered = filtered.filter(
      (m) =>
        m.name.toLowerCase().includes(term) ||
        m.mobile.includes(term) ||
        m.admission_number.toLowerCase().includes(term)
    );
  }

  if (groupId) {
    const ids = groupId.split(',');
    filtered = filtered.filter((m) => m.groups.some((g) => ids.includes(g.id)));
  }

  const start = page * limit;
  const slice = filtered.slice(start, start + limit);
  return {
    data: slice,
    pagination: {
      total_rows: filtered.length,
      page,
      limit
    }
  };
};

// ── Transactions (5 pending, 3 paid/success, 1 partially paid) ──

const now = new Date();
const daysAgo = (d: number) => {
  const dt = new Date(now);
  dt.setDate(dt.getDate() - d);
  return dt.toISOString();
};

const PENDING_ORDER_IDS = [
  'ord_f3a1b7c9e2',
  'ord_d8e4a2f1b6',
  'ord_c7b9d3e5a1',
  'ord_a2f6c8d4e7',
  'ord_e5b1a9c3d2'
];
const PAID_ORDER_IDS = ['ord_b4d2e8a6c1', 'ord_a9c3f7b5d4', 'ord_d1e5b8c2a7'];
const PARTIAL_ORDER_ID = 'ord_c6a4d9b3e8';

const getMemberPhone = (memberIndex: number) => {
  const m = MOCK_MEMBERS[memberIndex];
  return `+${m.country_code}${m.mobile}`;
};

const txBase = {
  remind_again: false,
  payment_link: 'https://pay.cofee.life/trial',
  type: 'group',
  order_short_url: '',
  receipt_url: '',
  payment_description: '',
  payment_method: '',
  payment_to: TRIAL_MOCK_IDS.ORG_NAME,
  is_split_payment: false,
  total_settled_amount: '0',
  total_paid_amount: '0',
  disabled_at: null,
  utr: ''
};

const MOCK_TRANSACTIONS = [
  // 5 pending
  ...Array.from({ length: 5 }, (_, i) => {
    const amt = MOCK_GROUPS[i % 3].amount;
    return {
      ...txBase,
      id: PENDING_ORDER_IDS[i],
      name: MOCK_MEMBERS[i].name,
      member_id: MOCK_MEMBERS[i].id,
      member_phone_number: getMemberPhone(i),
      note: `Monthly fee - ${MOCK_GROUPS[i % 3].name}`,
      amount: amt,
      total_amount: amt,
      original_amount_requested: amt,
      original_total_amount_requested: amt,
      status: 'processing',
      settlement_status: '',
      payment_mode: '',
      paid_at: null,
      due_at: daysAgo(5 - i),
      settled_at: '',
      group_id: MOCK_GROUPS[i % 3].id,
      group_name: MOCK_GROUPS[i % 3].name
    };
  }),
  // 3 paid (success + settled)
  ...Array.from({ length: 3 }, (_, i) => {
    const amt = MOCK_GROUPS[i % 3].amount;
    return {
      ...txBase,
      id: PAID_ORDER_IDS[i],
      name: MOCK_MEMBERS[5 + i].name,
      member_id: MOCK_MEMBERS[5 + i].id,
      member_phone_number: getMemberPhone(5 + i),
      note: `Monthly fee - ${MOCK_GROUPS[i % 3].name}`,
      amount: amt,
      total_amount: amt,
      original_amount_requested: amt,
      original_total_amount_requested: amt,
      status: 'success',
      settlement_status: 'settled',
      payment_mode: 'automatic',
      payment_method: 'upi',
      paid_at: daysAgo(10 - i),
      due_at: daysAgo(15 - i),
      settled_at: daysAgo(8 - i),
      total_settled_amount: amt,
      total_paid_amount: amt,
      utr: `UTR${String(900000000 + i * 1111).padStart(12, '0')}`,
      group_id: MOCK_GROUPS[i % 3].id,
      group_name: MOCK_GROUPS[i % 3].name
    };
  }),
  // 1 partially paid
  {
    ...txBase,
    id: PARTIAL_ORDER_ID,
    name: MOCK_MEMBERS[8].name,
    member_id: MOCK_MEMBERS[8].id,
    member_phone_number: getMemberPhone(8),
    note: `Monthly fee - ${MOCK_GROUPS[2].name}`,
    amount: '1000',
    total_amount: '1000',
    original_amount_requested: '1000',
    original_total_amount_requested: '1000',
    status: 'processing',
    settlement_status: '',
    payment_mode: 'automatic',
    payment_method: 'upi',
    paid_at: daysAgo(3),
    due_at: daysAgo(12),
    settled_at: '',
    is_split_payment: true,
    total_paid_amount: '600',
    total_settled_amount: '0',
    group_id: MOCK_GROUPS[2].id,
    group_name: MOCK_GROUPS[2].name
  }
];

export const getTransactionsMock = (
  status: string,
  page: number,
  limit: number
) => {
  let filtered = MOCK_TRANSACTIONS;
  if (status === 'paid') {
    filtered = MOCK_TRANSACTIONS.filter((t) => t.status === 'success');
  } else if (status === 'pending') {
    filtered = MOCK_TRANSACTIONS.filter((t) => t.status === 'pending');
  } else if (status === 'partially_paid') {
    filtered = MOCK_TRANSACTIONS.filter((t) => t.status === 'partially_paid');
  }

  const start = page * limit;
  const slice = filtered.slice(start, start + limit);
  return {
    data: slice.length > 0 ? slice : null,
    pagination: {
      total_rows: filtered.length,
      page,
      limit
    }
  };
};

// ── Team Management (org-level users) ──

const ORG_MEMBER_ROLES = [
  'Organisation Admin',
  'Branch Admin',
  'Group Admin',
  'Finance',
  'Organisation Admin'
];

const getGroupNames = (i: number) => {
  if (i === 2) return [MOCK_GROUPS[0].name, MOCK_GROUPS[1].name];
  if (i === 3) return [MOCK_GROUPS[2].name];
  return null;
};

const MOCK_ORG_MEMBERS = Array.from({ length: 5 }, (_, i) => ({
  user_id: `trial-orguser-${String(i + 1).padStart(3, '0')}`,
  user_name: `${FIRST_NAMES[i]} ${LAST_NAMES[i]}`,
  mobile: `99${String(80000000 + i * 1111111).slice(0, 8)}`,
  role_name: ORG_MEMBER_ROLES[i],
  status: 'active',
  user_organisation_role_id: `trial-uor-${String(i + 1).padStart(3, '0')}`,
  branch_name: i < 3 ? [TRIAL_MOCK_IDS.BRANCH_NAME] : null,
  group_name: getGroupNames(i)
}));

export const getOrgMembersMock = (page: number, limit: number) => {
  const start = page * limit;
  const slice = MOCK_ORG_MEMBERS.slice(start, start + limit);
  return {
    data: slice,
    pagination: {
      total_rows: MOCK_ORG_MEMBERS.length,
      page,
      limit
    }
  };
};

export const getInvitedMembersMock = () => ({
  data: [],
  pagination: { total_rows: 0, page: 0, limit: 10 }
});

// ── Member create / update (POST) ──

export const createMemberMock = () => ({
  data: {
    member_response: [{ status: 'success', errors: [] }],
    warning_records: []
  }
});

// ── Member detail (GET by ID) ──

export const getMemberDetailMock = (memberId: string) => {
  const member = MOCK_MEMBERS.find((m) => m.id === memberId);
  if (!member) return MOCK_MEMBERS[0];
  return {
    ...member,
    email: '',
    alternate_country_code: '91',
    alternate_mobile: '',
    date_of_birth: '',
    address_line_1: '',
    address_line_2: '',
    city: '',
    state: '',
    pincode: '',
    custom_fields: []
  };
};

// ── Group member contact numbers (Quick Collect tab) ──

export const getGroupMemberContactsMock = (groupId: string) =>
  MOCK_MEMBERS.filter((m) => m.groups.some((g) => g.id === groupId)).map(
    (m) => ({
      name: m.name,
      country_code: m.country_code,
      mobile: m.mobile
    })
  );

// ── Group members list (Group Details > Members tab) ──

export const getGroupMembersMock = (
  groupId: string,
  page: number,
  limit: number,
  search: string
) => {
  let filtered = MOCK_MEMBERS.filter((m) =>
    m.groups.some((g) => g.id === groupId)
  );

  if (search) {
    const term = search.toLowerCase();
    filtered = filtered.filter(
      (m) =>
        m.name.toLowerCase().includes(term) ||
        m.mobile.includes(term) ||
        m.admission_number.toLowerCase().includes(term)
    );
  }

  const start = page * limit;
  const slice = filtered.slice(start, start + limit);
  return {
    data: slice,
    pagination: {
      total_rows: filtered.length,
      page,
      limit
    }
  };
};

// ── Transaction detail (Payment Details modal) ──

export const getTransactionDetailMock = (orderId: string) => {
  const txn = MOCK_TRANSACTIONS.find((t) => t.id === orderId);
  if (!txn) return MOCK_TRANSACTIONS[0];
  const member = MOCK_MEMBERS.find((m) => m.id === txn.member_id);
  return {
    ...txn,
    total_amount: txn.amount,
    closed_amount: '0',
    original_amount_requested: txn.amount,
    member_phone_number: member
      ? `+${member.country_code}${member.mobile}`
      : '',
    member_secondary_phone_number: '',
    fee_amount_configuration: [],
    fine_amount: '0',
    cgst_amount: '0',
    sgst_amount: '0',
    igst_amount: '0',
    cgst_percentage: '0',
    sgst_percentage: '0',
    igst_percentage: '0',
    total_gst: '0',
    total_discount_amount: '0',
    no_of_sessions: 0,
    cost_per_session: '0',
    is_auto_debit_in_progress: false
  };
};

// ── Payment order history (Transaction history in payment details) ──

export const getPaymentOrderHistoryMock = (orderId: string) => {
  const txn = MOCK_TRANSACTIONS.find((t) => t.id === orderId);
  if (!txn) return [];

  if (txn.status === 'pending') return [];

  const entries = [];

  if (txn.status === 'success') {
    entries.push({
      type: 'payment',
      payment_mode: txn.payment_mode,
      payment_method: txn.payment_method,
      paid_amount: txn.total_paid_amount,
      paid_at: txn.paid_at,
      settled_at: txn.settled_at,
      settlement_status: txn.settlement_status,
      transaction_id: txn.id,
      utr: txn.utr,
      payment_description: txn.payment_description
    });
  }

  if (txn.is_split_payment) {
    entries.push({
      type: 'payment',
      payment_mode: txn.payment_mode,
      payment_method: txn.payment_method,
      paid_amount: txn.total_paid_amount,
      paid_at: txn.paid_at,
      settled_at: '',
      settlement_status: '',
      transaction_id: `${txn.id}-split-1`,
      utr: '',
      payment_description: ''
    });
  }

  return entries;
};

// ── Account details (Branch Settings) ──

export const getAccountDetailsMock = () => ({
  branch: {
    id: 1,
    branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
    organisation_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    bank_account: {
      bank_account_name: 'Acme Academy',
      bank_account_number: '1234567890123456',
      ifsc: 'SBIN0001234',
      bank_name: 'State Bank of India',
      nick_name: 'Primary Account',
      status: 'verified',
      logo: ''
    },
    upi: []
  },
  organisation: {
    id: 2,
    organisation_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    bank_account: null,
    upi: []
  },
  additionalAccounts: []
});
